import React from 'react';
import './App.css';
import MainApp from "./MainApp";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import {store} from './store/store';

class App extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <MainApp/>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default App;
